module.exports = __webpack_public_path__ + "fonts/Bareona-2.935832b2.ttf";